// ============================================================
// src/context/AuthContext.jsx
// ============================================================
import React, { createContext, useContext, useState } from 'react';
import { login as apiLogin, logout as apiLogout, getCurrentUser } from '../api/authApi';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getCurrentUser);

  async function login(ee_number, password, role) {
    const res = await apiLogin(ee_number, password, role);
    setUser(res.user);
    return res.user;
  }

  async function logout() {
    await apiLogout();
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
